export default "<r-unified-home #unifiedHomeRef></r-unified-home>\n";